export default "__VITE_ASSET__XtQ2pGs4__"